import React, { Component } from 'react';
import { string, bool, shape, object, number, func, objectOf, arrayOf, any } from 'prop-types';
import cx from 'classnames';
import { advertiserShape } from '../../../helpers/propTypes';
import { STATION_CHART_ID, ADTYPE_CHART_ID, MAX_NUMBER_TABLE_ROWS_TO_TRUNCATE, newAdUsersMetricKey } from '../../../helpers/constant';
import { FormControl, MenuItem, Select, MuiThemeProvider } from '@material-ui/core';
import ModuleExport from '../../ModuleExport';
import { PlacementAdTypeChart } from './PlacementAdTypeChart';
import PlacementAdTypeTable from './PlacementAdTypeTable';
import PlacementStationTable from './PlacementStationTable';
import { PlacementStationChart } from './PlacementStationChart';
import ShowAllAds from '../../Modal/ShowAllAds';
import {
  adTypeShape,
  stationShape,
  AD_USERS_OPTION,
  AD_VISITS_OPTION,
  PLACEMENT_AD_TYPE_CHART_FILE_NAME,
  NEW_AD_USERS,
  VISITS_OF_ADS_OPTION, PLACEMENT_STATION_CHART_FILE_NAME, AVG_AD_COST_OPTION
} from './constants';
import {
  SINGLE_PAGE_WEB_ANALYTICS_DATA,
  MIN_LENGTH_PLACEMENT_STATION,
} from '../../../helpers/constant';
import { get } from 'lodash';
import { defaultChartSelector } from '../../../helpers/defaultInfo';
import DeleteReportItemButton from '../../DeleteReportItem';
import { getNumberOfChartAndTableInReport } from '../Report/helper';
import {
  checkEnableFeatureFlag,
  getEnabledFlags,
  shouldShowNewAdUserSunsetDisclaimer,
  shouldShowTileByDateCompare,
} from '../../../helpers/common';
import { NewAdUserSunsetDisclaimer } from '../ChartDisclaimer';

import styles from './styles.scss';
import { withStyles } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';


const defaultAdType = get(defaultChartSelector, [ADTYPE_CHART_ID, 'adType']);
const defaultStationType = get(defaultChartSelector, [STATION_CHART_ID, 'stationType']);
const muiStyle = {
  arrowDropDown: {
    color: '#2196f3'
  }
};
const customStyles = createTheme({
  overrides: {
    MuiSelect: {
      selectMenu: {
        textOverflow: "clip",
      }
    }
  }
})
export class PlacementAnalytics extends Component {
  static propTypes = {
    adTypeData: arrayOf(adTypeShape).isRequired,
    stationData: arrayOf(stationShape).isRequired,
    inpdf: bool,
    campaign: shape({
      chartData: object,
      campaign_id: number.isRequired
    }),
    urlApi: objectOf(string),
    advertiser: advertiserShape,
    currentPayload: shape({
      advertiserId: number,
      campaignId: number,
      tab: string
    }),
    navigateCampaignWithTab: func,
    page: number,
    beginStation: number,
    numberPage: number,
    typeOptions: shape({
      adUser: shape({ value: string, label: string }),
      adVisit: shape({ value: string, label: string }),
      avgAdCost: shape({ value: string, label: string }),
      visitOfAds: shape({ value: string, label: string }),
      newAdUsers: shape({ value: string, label: string }),
    }),
    adTypeTitle: string,
    stationTitle: string,
    classes: shape({ any }),
    isAvgCostDisabled: bool,
    chartData: shape({ any }),
    notifications: arrayOf(any),
    setChartSelector: func,
    selectedAdType: string,
    selectedStationType: string,
    isCustomReport: bool,
    showInReportConfig: shape({
      placementAdTypeChart: bool,
      placementAdTypeTable: bool,
      placementStationChart: bool,
      placementStationTable: bool,
    }),
    currentStep: string,
    reportAdTypeChartSelectors: arrayOf(objectOf(string)),
    reportStationChartSelectors: arrayOf(objectOf(string)),
    setReportChartSelector: func,
    countInReportConfig: shape({
      placementAdTypeChart: arrayOf(number),
      placementAdTypeTable: arrayOf(number),
      placementStationChart: arrayOf(number),
      placementStationTable: arrayOf(number),
    }),
    stationTableSortSelector: shape({
        sortKey: string,
        sortType: string
    }),
    adTypeTableSortSelector: shape({
        sortKey: string,
        sortType: string,
    }),
    enabledFlags: arrayOf(string),
    isHiddenChart: bool,
    isTableOnly: bool,
    rowOnFirstPage: number
  };

  static defaultProps = {
    adTypeTitle: 'Ad Type',
    stationTitle: 'Stations',
    campaign: {},
    showInReportConfig: {},
    countInReportConfig: {
      placementAdTypeChart: [1],
      placementAdTypeTable: [1],
      placementStationChart: [1],
      placementStationTable: [1],
    },
    typeOptions: {
      visitOfAds: {
        value: VISITS_OF_ADS_OPTION,
        label: 'Ad Visits/Ads'
      },
      adVisit: {
        value: AD_VISITS_OPTION,
        label: 'Ad Visits'
      },
      adUsers: {
        value: AD_USERS_OPTION,
        label: 'Ad Users'
      },
      avgAdCost: {
        value: AVG_AD_COST_OPTION,
        label: 'Avg. Ad Cost'
      },
      newAdUsers: {
        value: NEW_AD_USERS,
        label: 'New Ad Users',
      },
    }
  };

  state = {
    isDrillDownOpen: false
  };

  handleCellClick = (data, chartId) => {
    const { urlApi, campaign, isCustomReport } = this.props;
    if (isCustomReport) {
      return;
    }
    const { stationId, title, isStation } = data;
    const detailInfo = {
      urlApi,
      adType: !stationId ? title : undefined,
      stationId: isStation ? stationId : null,
      campaignId: campaign.campaign_id,
      adSources: !isStation && stationId && [stationId],
      stationName: stationId && stationId.toString().includes('TTWN') ?  stationId : '',
    };

    this.setState({
      chartId,
      isDrillDownOpen: true,
      detailInfo: { ...detailInfo }
    });
  };

  handleCloseDrillDown = () => {
    const { navigateCampaignWithTab, currentPayload } = this.props;
    const { advertiserId, campaignId, tab } = currentPayload;
    navigateCampaignWithTab && navigateCampaignWithTab(advertiserId, campaignId, tab);
    this.setState({
      isDrillDownOpen: false,
      detailInfo: {}
    });
  };

  handleAdTypeChange = (itemIndex) => (e) => {
    const { setChartSelector, campaign, setReportChartSelector, isCustomReport } = this.props;
    const campaignId = campaign.campaign_id;
    const newType = e.target.value;
    setChartSelector && setChartSelector(
      campaignId,
      ADTYPE_CHART_ID,
      { adType: newType }
    );
    isCustomReport
    &&setReportChartSelector
    && setReportChartSelector(ADTYPE_CHART_ID, itemIndex, { adType: newType });
  };

  handleStationTypeChange = (itemIndex) => (e) => {
    const { setChartSelector, campaign, setReportChartSelector, isCustomReport } = this.props;
    const campaignId = campaign.campaign_id;
    const newType = e.target.value;
    setChartSelector && setChartSelector(
      campaignId,
      STATION_CHART_ID,
      { stationType: newType }
    );
    isCustomReport
    && setReportChartSelector
    && setReportChartSelector(STATION_CHART_ID, itemIndex, { stationType: newType });
  };

  drawAdTypeDataSelector = (reportSelectedAdType, itemIndex) => {
    const { typeOptions, selectedAdType, classes, enabledFlags, advertiser, campaign, isCustomReport, reportBuilder } = this.props;
    const { visitOfAds, adVisit, newAdUsers } = typeOptions;
    const customReportDateRange = get(reportBuilder, 'reportProperties.reportDateRange');
    const isNewAdUserSelectorShow = isCustomReport ?    
                                    shouldShowTileByDateCompare({advertiser, campaign, customReportDateRange}) :
                                    shouldShowTileByDateCompare({advertiser, campaign});
    const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && isNewAdUserSelectorShow;
   
    return (
      <MuiThemeProvider theme={customStyles}>
        <FormControl className={styles.dataDropDown}>
          <Select
            value={reportSelectedAdType || selectedAdType}
            className={styles.selector}
            onChange={this.handleAdTypeChange(itemIndex)}
            inputProps={{ classes: { icon: classes.arrowDropDown } }}
          >
            <MenuItem value={visitOfAds.value}>{visitOfAds.label}</MenuItem>
            <MenuItem value={adVisit.value}>{adVisit.label}</MenuItem>
            {isNewAdUsersEnabled && <MenuItem value={newAdUsers.value}>{newAdUsers.label}</MenuItem>}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    );
  }

  drawStationDataSelector(reportSelectedStationType, itemIndex) {
    const { typeOptions, 
      classes, 
      isAvgCostDisabled,
      selectedStationType, 
      enabledFlags, 
      advertiser, 
      campaign,
      reportBuilder,
      isCustomReport
      } = this.props;
    const customReportDateRange = get(reportBuilder, 'reportProperties.reportDateRange');
    const { visitOfAds, adVisit, avgAdCost, newAdUsers } = typeOptions;
    const isNewAdUserSelectorShow = isCustomReport ? 
                                    shouldShowTileByDateCompare({advertiser, campaign, customReportDateRange}) :
                                    shouldShowTileByDateCompare({advertiser, campaign});
    const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]) && isNewAdUserSelectorShow;
    return (
      <MuiThemeProvider theme={customStyles}>
        <FormControl className={styles.dataDropDown}>
          <Select
            value={reportSelectedStationType || selectedStationType}
            className={styles.selector}
            onChange={this.handleStationTypeChange(itemIndex)}
            inputProps={{ classes: { icon: classes.arrowDropDown } }}
          >
            <MenuItem value={visitOfAds.value}>{visitOfAds.label}</MenuItem>
            {!isAvgCostDisabled && <MenuItem value={avgAdCost.value}>{avgAdCost.label}</MenuItem>}
            <MenuItem value={adVisit.value}>{adVisit.label}</MenuItem>
            {isNewAdUsersEnabled && <MenuItem value={newAdUsers.value}>{newAdUsers.label}</MenuItem>}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    );
  }

  formatChartData(chartData) {
    const formattedData = (chartData || []).map((item) => {
      return {
        ...item,
        visitOfads: item.visitOfads ? Number(item.visitOfads.toFixed(2)) : item.visitOfads,
      }
    });
    return formattedData;
  }

  adTypeRef = React.createRef();
  stationRef = React.createRef();
  render() {
    const {
      inpdf,
      campaign,
      advertiser,
      page,
      beginStation,
      numberPage,
      adTypeTitle,
      stationTitle,
      typeOptions,
      adTypeData,
      stationData,
      chartData,
      notifications,
      selectedAdType,
      selectedStationType,
      isCustomReport,
      showInReportConfig,
      currentStep,
      countInReportConfig,
      reportAdTypeChartSelectors,
      reportStationChartSelectors,
      stationTableSortSelector,
      enabledFlags,
      adTypeTableSortSelector,
      isHiddenChart,
      isTableOnly,
      rowOnFirstPage,
    } = this.props;
    const formattedAdTypeData = this.formatChartData(adTypeData);
    const formattedStationData = this.formatChartData(stationData);
    const campaignAvgAdCost = get(chartData, 'avgAdCost');
    const { detailInfo, isDrillDownOpen, chartId } = this.state;
    const { placementAdTypeChart, placementStationChart, placementStationTable, placementAdTypeTable} = showInReportConfig;
    const isFirstPDFPage = !inpdf || (inpdf && page === 0);
    const isBeginStationChart = !inpdf || (inpdf && beginStation === page);
    const isBeginStationTable = !inpdf || (inpdf && beginStation <= page);
    let displayAdTypeChart = isFirstPDFPage;
    let displayAdTypeTable = isFirstPDFPage;
    let displayStationChart = isBeginStationChart;
    let displayStationTable = isBeginStationTable;
    let showDeleteAdTypeChartButton = false;
    let showDeleteAdTypeTableButton = false;
    let showDeleteStationChartButton = false;
    let showDeleteStationTableButton = false;
    if (isCustomReport) {
      displayAdTypeChart = placementAdTypeChart && displayAdTypeChart;
      showDeleteAdTypeChartButton = placementAdTypeChart;
      displayStationChart = placementStationChart && displayStationChart;
      showDeleteStationChartButton = placementStationChart;
      displayStationTable = placementStationTable && displayStationTable;
      showDeleteStationTableButton = placementStationTable;
      displayAdTypeTable = placementAdTypeTable && displayAdTypeTable;
      showDeleteAdTypeTableButton = placementAdTypeTable;
    }
    const isGrandTotalStationDisplay = !inpdf || (inpdf && page === numberPage - 1);
    let rowsPerAdPage = 0;
    let rowsPerStationPage = 0;
    const {
      placementAdTypeChart: adTypeChartCount,
      placementAdTypeTable: adTypeTableCount,
      placementStationChart: stationChartCount,
      placementStationTable: stationTableCount,
    } = countInReportConfig;
    const adTypeChartAndTableCount = getNumberOfChartAndTableInReport(adTypeChartCount, adTypeTableCount);
    const stationChartAndTableCount = getNumberOfChartAndTableInReport(stationChartCount, stationTableCount);
    const isNewAdUsersEnabled = checkEnableFeatureFlag(enabledFlags, [newAdUsersMetricKey]);
    const isNewAdUserSelectedForAdType = selectedAdType === get(typeOptions, 'newAdUsers.value');
    const isNewAdUserSelectedForStation = selectedStationType === get(typeOptions, 'newAdUsers.value');

    return (
      <div className={styles.placementAnalytics}>
        {Array(adTypeChartAndTableCount).fill('').map((_item, index) => {
          let key = adTypeChartCount[index] || adTypeTableCount[index] || (index + 1);
          const prefixKey = adTypeChartCount[index] ? 'adTypeChart' : 'adTypeTable';
          const isDisplayAdTypeChartInPreview = !!adTypeChartCount.find(item => item === index + 1) && !isHiddenChart || isTableOnly;
          displayAdTypeChart = isFirstPDFPage && isDisplayAdTypeChartInPreview && !isHiddenChart;
          displayAdTypeTable = isFirstPDFPage && !!adTypeTableCount.find(item => item === index + 1) && (inpdf ? isHiddenChart : true);
          showDeleteAdTypeChartButton = isCustomReport && displayAdTypeChart;
          const displayAdTypeChartContainer = !inpdf && (displayAdTypeChart || displayAdTypeTable) || inpdf && displayAdTypeChart;
          const reportSelectedAdType = get(reportAdTypeChartSelectors,[index, 'adType']);
          const adTypeChartAxis = get(typeOptions, [reportSelectedAdType || selectedAdType, 'label'], typeOptions.visitOfAds.label);
          if (inpdf) {
            // show table rows on full pdf page and add one more row if this page doesn't display the Grand Total row
            rowsPerAdPage = 25;
            // show fewer rows on the first page of adtype/station because of the chart above the table
            if ( page === 0 && displayAdTypeChart ) {
              rowsPerAdPage = isGrandTotalStationDisplay ? MIN_LENGTH_PLACEMENT_STATION : MIN_LENGTH_PLACEMENT_STATION + 1;
            }
            if( page === 0 && isTableOnly && rowOnFirstPage) {
              const numberRowOnFirstPage = rowOnFirstPage || MIN_LENGTH_PLACEMENT_STATION;
              rowsPerAdPage = isGrandTotalStationDisplay ? numberRowOnFirstPage : numberRowOnFirstPage + 1;
            }
          }
          return (
            <div key={prefixKey + key} className={cx({[styles.adTypeContainerMainView]: !isCustomReport}, styles.adTypeContainer)}>
              {displayAdTypeChartContainer &&
                <div ref={this.adTypeRef} className={cx({[styles.deleteItemContainer]: currentStep === 'customize' && displayAdTypeChart}, styles.itemContainer)}>
                  {showDeleteAdTypeChartButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteAdTypeChartButton}
                      parentId="placement"
                      componentId="placementAdTypeChart"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  {displayAdTypeChart &&
                    <ModuleExport
                      exportImg={this.adTypeRef}
                      fileName={PLACEMENT_AD_TYPE_CHART_FILE_NAME}
                      disableCsvExport
                    />
                  }
                  <div className={styles.header}>
                    <div>{adTypeTitle}</div>
                  </div>
                  <div className={styles.dropDownBox}>
                    {this.drawAdTypeDataSelector(reportSelectedAdType, index)}
                  </div>
                  {displayAdTypeChart &&
                    <div className={styles.chartContainer}>
                      <div className={styles.chart}>
                        <PlacementAdTypeChart
                          data={formattedAdTypeData}
                          selectedDataType={reportSelectedAdType || selectedAdType}
                          xAxisTitle={adTypeChartAxis}
                        />
                      </div>
                      {shouldShowNewAdUserSunsetDisclaimer(
                        campaign,
                        isNewAdUserSelectedForAdType
                      ) && (
                        <NewAdUserSunsetDisclaimer
                          customStyle={styles.adTypeDisclaimer}
                        />
                      )}
                    </div>
                  }
                </div>
              }
              {displayAdTypeTable &&
                <div className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteAdTypeTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteAdTypeTableButton}
                      parentId="placement"
                      componentId="placementAdTypeTable"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <PlacementAdTypeTable
                    data={adTypeData}
                    onCellClick={this.handleCellClick}
                    inpdf={inpdf}
                    page={page}
                    campaignAvgAdCost={campaignAvgAdCost}
                    rowsPerPage={rowsPerAdPage}
                    isGrandTotalDisplay
                    isCustomReport={isCustomReport}
                    displayAdChart={isDisplayAdTypeChartInPreview}
                    itemIndex={index}
                    tableSortSelector={adTypeTableSortSelector}
                    isNewAdUsersEnabled={isNewAdUsersEnabled}
                    selectedDataType={reportSelectedAdType || selectedAdType}
                    rowsFirstPage={rowOnFirstPage}
                  />
                </div>
              }
            </div>
          )
        })}
        {Array(stationChartAndTableCount).fill('').map((_item, index) => {
          let key = stationChartCount[index] || stationTableCount[index] || (index + 1);
          const prefixKey = stationChartCount[index] ? 'stationChart' : 'stationTable';
          const isDisplayStationChartInPreview = !!stationChartCount.find(item => item === index + 1) && !isHiddenChart || isTableOnly;
          displayStationChart = isBeginStationChart && isDisplayStationChartInPreview && !isHiddenChart;
          displayStationTable = isBeginStationTable && !!stationTableCount.find(item => item === index + 1) && (inpdf ? isHiddenChart : true);
          showDeleteStationChartButton = isCustomReport && displayStationChart;
          const reportSelectedStationType = get(reportStationChartSelectors, [index, 'stationType']);
          const stationChartAxis = get(typeOptions, [reportSelectedStationType || selectedStationType, 'label'], typeOptions.visitOfAds.label);
          const displayStationChartContainer = !inpdf && (displayStationChart || displayStationTable) || inpdf && displayStationChart;
          if (inpdf) {
            // show table rows on full pdf page and add one more row if this page doesn't display the Grand Total row
            rowsPerStationPage = 25;
            // show fewer rows on the first page of adtype/station because of the chart above the table
            if (page === beginStation && displayStationChart) {
              rowsPerStationPage = isGrandTotalStationDisplay ? MIN_LENGTH_PLACEMENT_STATION : MIN_LENGTH_PLACEMENT_STATION + 1
            }
            if( page === 0 && isTableOnly && rowOnFirstPage) {
              const numberRowOnFirstPage = rowOnFirstPage || MIN_LENGTH_PLACEMENT_STATION;
              rowsPerStationPage = isGrandTotalStationDisplay ? numberRowOnFirstPage : numberRowOnFirstPage + 1;
            }
          }
          return (
            <div key={prefixKey + key} className={cx({[styles.adTypeContainerMainView]: !isCustomReport}, styles.adTypeContainer)}>
              {displayStationChartContainer &&
                <div ref={this.stationRef} className={cx({[styles.deleteItemContainer]: currentStep === 'customize' && displayStationChart}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteStationChartButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteStationChartButton}
                      parentId="placement"
                      componentId="placementStationChart"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  {displayStationChart &&
                    <ModuleExport
                      exportImg={this.stationRef}
                      fileName={PLACEMENT_STATION_CHART_FILE_NAME}
                      disableCsvExport
                    />
                  }
                  <div className={styles.header}>
                    <div>{stationTitle}</div>
                  </div>
                  <div className={styles.dropDownBox}>
                    {this.drawStationDataSelector(reportSelectedStationType, index)}
                  </div>
                  {displayStationChart &&
                    <div className={styles.chartContainer}>
                      <div className={styles.chart}>
                        <PlacementStationChart
                          data={formattedStationData}
                          yAxisTitle={stationChartAxis}
                          selectedDataType={reportSelectedStationType || selectedStationType}
                        />
                        {shouldShowNewAdUserSunsetDisclaimer(
                          campaign,
                          isNewAdUserSelectedForStation
                        ) && (
                          <NewAdUserSunsetDisclaimer
                            customStyle={styles.stationDisclaimer}
                          />
                        )}
                      </div>
                    </div>
                  }
                </div>
              }
              {
                displayStationTable && <div className={cx({[styles.deleteItemContainer]: currentStep === 'customize'}, styles.tableContainer, styles.itemContainer)}>
                  {showDeleteStationTableButton &&
                    <DeleteReportItemButton
                      isDelete={showDeleteStationTableButton}
                      parentId="placement"
                      componentId="placementStationTable"
                      customClassName={styles.deleteButton}
                      itemIndex={index}
                    />
                  }
                  <PlacementStationTable
                    data={stationData}
                    onCellClick={this.handleCellClick}
                    beginStation={beginStation}
                    inpdf={inpdf}
                    page={page}
                    rowsPerPage={rowsPerStationPage}
                    isGrandTotalDisplay={isGrandTotalStationDisplay}
                    campaignAvgAdCost={campaignAvgAdCost}
                    displayStationChart={isDisplayStationChartInPreview}
                    isCustomReport={isCustomReport}
                    itemIndex={index}
                    tableSortSelector={stationTableSortSelector}
                    isNewAdUsersEnabled={isNewAdUsersEnabled}
                    selectedDataType={reportSelectedStationType || selectedStationType}
                    rowsFirstPage={rowOnFirstPage}
                  />
                </div>
              }
            </div>
          )
        })}
        <ShowAllAds
          id={chartId}
          currentChartId={chartId}
          campaign={campaign}
          detailUrl={detailInfo}
          advertiser={advertiser}
          open={isDrillDownOpen}
          onClose={this.handleCloseDrillDown}
          detailInfo={detailInfo}
          notifications={notifications}
        />
      </div>
    );
  }
}

import { connect } from 'react-redux';
import getUrlApi from '../../../helpers/getUrlApi';
import { selectCurrentRoutePayload } from '../../../state/modules/routing';
import { redirectToCampaignTabs } from '../../../state/modules/routing/actions';
import { setChartSelector } from '../../../state/modules/app/campaign';
import { setReportChartSelector } from '../../../state/modules/app/reportBuilder/actions';
import { is } from '@amcharts/amcharts4/core';

export default connect(
  (state, props) => {
    const { chartData, campaign } = props;
    const adTypeData = get(chartData, [ADTYPE_CHART_ID, 'data'], []);
    const stationData = get(chartData, [STATION_CHART_ID, 'data'], []);
    const isAvgCostDisabled = get(chartData, 'avgAdCost') == null;
    const selectedAdType = get(campaign, ['chartSelector', ADTYPE_CHART_ID, 'adType'], defaultAdType);
    const selectedStationType = get(campaign, ['chartSelector', STATION_CHART_ID, 'stationType'], defaultStationType);
    const currentStep = get(state, 'reportBuilder.currentStep', '');
    const reportChartSelector = props.reportChartSelector || get(state, 'reportBuilder.chartSelector', {});
    return {
      currentPayload: selectCurrentRoutePayload(state),
      urlApi: getUrlApi(state),
      adTypeData,
      stationData,
      isAvgCostDisabled,
      selectedAdType,
      selectedStationType,
      currentStep,
      reportAdTypeChartSelectors: get(reportChartSelector, [ADTYPE_CHART_ID], []),
      reportStationChartSelectors: get(reportChartSelector, [STATION_CHART_ID], []),
      enabledFlags: getEnabledFlags(props, state),
    };
  },
  {
    redirectToCampaignTabs,
    setChartSelector,
    setReportChartSelector,
  }
)(withStyles(muiStyle)(PlacementAnalytics));
